import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import {
    GET_CATEGORIES_NAME,
    GET_COLLECTIONS_NAME,
    GET_LUMEN,
    GET_TEMPERATURE,
    GET_WATTAGE_NAME,
    GET_DISTRIBUTION_NAME,
    GET_CERTIFICATION_NAME,
} from "../../../services/graphql-query";
import { Checkbox, Select, ListItemText, MenuItem, InputLabel, OutlinedInput, FormControl, Slider } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 5.5 + ITEM_PADDING_TOP,
            width: 200,
        },
    },
};

const MenuProps1 = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 5.5 + ITEM_PADDING_TOP,
            width: 150,
        },
    },
};

const SelectFilter = (props) => {

    const { selectCategory, setSelectCategory, selectCollection, setSelectCollection, selectLumen, setSelectLumen, selectTemperature, setSelectTemperature, selectWattage, setSelectWattage, selectDistribution, setSelectDistribution, selectCertification, setSelectCertification, isCategory, setCategory, isCollection, setCollection, isLumen, setLumen, isTemperature, setTemperature, isWattage, setWattage, isDistribution, setDistribution, isCertification, setCertification } = props

    const [isResourceCategory, setResourceCategory] = useState([]);
    const [isResourceCollection, setResourceCollection] = useState([]);
    const [isResourceLumen, setResourceLumen] = useState([]);
    const [isResourceTemperature, setResourceTemperature] = useState([]);
    const [isResourceWattage, setResourceWattage] = useState([]);
    const [isResourceDistribution, setResourceDistribution] = useState([]);
    const [isResourceCertification, setResourceCertification] = useState([]);

    const category = useQuery(GET_CATEGORIES_NAME, {
        variables: { totalCategories: 100 },
        onCompleted: (res) => {
            let category_uniques = [];
            let categories_data = res.categories.data.filter((element) => {
                const isDuplicate = category_uniques.includes(element.attributes.name);
                if (!isDuplicate) {
                    category_uniques.push(element.attributes.name);
                    return true;
                }
                return false;
            });

            setCategory(categories_data);
            setResourceCategory(categories_data);
        }
    });
    const collection = useQuery(GET_COLLECTIONS_NAME, {
        variables: { totalCollections: 100 },
        onCompleted: (res) => {
            let collections_uniques = [];
            let collections_data = res.collections.data.filter((element) => {
                const isDuplicate = collections_uniques.includes(element.attributes.name);
                if (!isDuplicate) {
                    collections_uniques.push(element.attributes.name);
                    return true;
                }
                return false;
            });
            setCollection(collections_data);
            setResourceCollection(collections_data)
        }
    });
    const lumen = useQuery(GET_LUMEN, {
        variables: { totalLemun: 100 },
        onCompleted: (res) => {
            let lumens_uniques = [];
            let lumens_data = res.lumens.data.filter((element) => {
                const isDuplicate = lumens_uniques.includes(element.attributes.Lumen);
                if (!isDuplicate) {
                    lumens_uniques.push(element.attributes.Lumen);
                    return true;
                }
                return false;
            })
            setLumen(lumens_data);
            setResourceLumen(lumens_data)
        }
    });
    const temperature = useQuery(GET_TEMPERATURE, {
        variables: { totalTemperature: 100 },
        onCompleted: (res) => {
            let temperatures_uniques = [];
            let temperatures_data = res.temperatures.data.filter((element) => {
                const isDuplicate = temperatures_uniques.includes(element.attributes.value_temperature);
                if (!isDuplicate) {
                    temperatures_uniques.push(element.attributes.value_temperature);
                    return true;
                }
                return false;
            })
            setTemperature(temperatures_data);
            setResourceTemperature(temperatures_data);
        }
    });
    const wattage = useQuery(GET_WATTAGE_NAME, {
        variables: { totalWattage: 100 },
        onCompleted: (res) => {
            let wattage_uniques = [];
            let wattage_data = res.wattages.data.filter((element) => {
                const isDuplicate = wattage_uniques.includes(element.attributes.Watt);
                if (!isDuplicate) {
                    wattage_uniques.push(element.attributes.Watt);
                    return true;
                }
                return false;
            });
            setWattage(wattage_data);
            setResourceWattage(wattage_data)
        }
    });
    const distribution = useQuery(GET_DISTRIBUTION_NAME, {
        variables: { totalDistribution: 100 },
        onCompleted: (res) => {
            let distributes_uniques = [];
            let distributes_data = res.distributions.data.filter((element) => {
                const isDuplicate = distributes_uniques.includes(element.attributes.Abbreviation);
                if (!isDuplicate) {
                    distributes_uniques.push(element.attributes.Abbreviation);
                    return true;
                }
                return false;
            });
            setDistribution(distributes_data);
            setResourceDistribution(distributes_data)
        }
    });
    const certification = useQuery(GET_CERTIFICATION_NAME, {
        variables: { totalCertification: 100 },
        onCompleted: (res) => {
            let certifications_uniques = [];
            let certifications_data = res.certifications.data.filter((element) => {
                const isDuplicate = certifications_uniques.includes(element.attributes.Name);
                if (!isDuplicate) {
                    certifications_uniques.push(element.attributes.Name);
                    return true;
                }
                return false;
            });
            setCertification(certifications_data);
            setResourceCertification(certifications_data)
        }
    });

    useEffect(() => {
        const collections = [];

        if (selectCategory.length) {
            isResourceCollection.map((item) => {
                selectCategory.map((category) => {
                    if (item?.attributes?.category?.data?.attributes?.name === category) {
                        collections.push(item);
                    }
                })
            })
        } else {
            isResourceCollection.map((item) => {
                collections.push(item);
            })
        }

        setCollection(collections);
        setSelectCollection([]);

    }, [selectCategory]);

    useEffect(() => {

        const lemuns = [];
        const wattages = [];
        const distributions = [];
        const certifications = [];

        if (selectCollection.length) {

            isResourceLumen.map((item) => {
                selectCollection.map((collection) => {
                    if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                        lemuns.push(item);
                    }
                })
            })

            isResourceWattage.map((item) => {
                selectCollection.map((collection) => {
                    if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                        wattages.push(item);
                    }
                })
            })

            isResourceDistribution.map((item) => {
                selectCollection.map((collection) => {
                    if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                        distributions.push(item);
                    }
                })
            })

            isResourceCertification.map((item) => {
                selectCollection.map((collection) => {
                    if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                        certifications.push(item);
                    }
                })
            })

        } else {

            if (selectCategory.length) {
                isResourceLumen.map((item) => {
                    selectCategory.map((category) => {
                        if (item?.attributes?.category?.data?.attributes?.name === category) {
                            lemuns.push(item)
                        }
                    })
                })

                isResourceWattage.map((item) => {
                    selectCategory.map((category) => {
                        if (item?.attributes?.category?.data?.attributes?.name === category) {
                            wattages.push(item);
                        }
                    })
                })

                isResourceDistribution.map((item) => {
                    selectCategory.map((category) => {
                        if (item?.attributes?.category?.data?.attributes?.name === category) {
                            distributions.push(item);
                        }
                    })
                })

                isResourceCertification.map((item) => {
                    selectCategory.map((category) => {
                        if (item?.attributes?.category?.data?.attributes?.name === category) {
                            certifications.push(item);
                        }
                    })
                })

            } else {

                isResourceLumen.map((item) => {
                    lemuns.push(item)
                })

                isResourceWattage.map((item) => {
                    wattages.push(item);
                })

                isResourceDistribution.map((item) => {
                    distributions.push(item);
                })

                isResourceCertification.map((item) => {
                    certifications.push(item);
                })
            }
        }

        setLumen(lemuns);
        setWattage(wattages);
        setDistribution(distributions);
        setCertification(certifications);

        setSelectLumen([]);
        setSelectWattage([]);
        setSelectDistribution([]);
        setSelectCertification([]);

    }, [selectCollection]);

    useEffect(() => {

        const temperatures = [];

        if (selectLumen.length) {
            isResourceLumen.map((item) => {
                selectLumen.map((lumen) => {
                    if (item?.attributes?.Lumen === lumen) {
                        temperatures.push(item?.attributes?.temperature?.data);
                    }
                })
            })
        } else {
            if (selectCollection.length) {
                isResourceTemperature.map((item) => {
                    selectCollection.map((colleciton) => {
                        if (item.attributes?.collection?.data?.attributes?.name === colleciton) {
                            temperatures.push(item)
                        }
                    })
                })
            } else {
                isResourceTemperature.map((item) => {
                    temperatures.push(item)
                })
            }
        }

        setTemperature(temperatures);
        setSelectTemperature([]);

    }, [selectLumen]);

    const handleChangeCategory = (event) => {
        const {
            target: { value },
        } = event;

        setSelectCategory(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    const handleChangeCollection = (event) => {
        const {
            target: { value },
        } = event;
        setSelectCollection(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    const handleChangeLumen = (event) => {
        const {
            target: { value },
        } = event;
        setSelectLumen(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    const handleChangeTemperature = (event) => {
        const {
            target: { value },
        } = event;
        setSelectTemperature(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    const handleChangeWattage = (event) => {
        const {
            target: { value },
        } = event;
        setSelectWattage(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    const handleChangeDistribution = (event) => {
        const {
            target: { value },
        } = event;
        setSelectDistribution(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    const handleChangeCertification = (event) => {
        const {
            target: { value },
        } = event;
        setSelectCertification(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    return (
        <React.Fragment>
            <FormControl sx={{ m: 1, width: 230 }}>
                <InputLabel id="demo-multiple-checkbox-label">Category</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectCategory}
                    onChange={handleChangeCategory}
                    input={<OutlinedInput label="Category" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                >
                    {isCategory.map((item, index) => (
                        <MenuItem key={index} value={item?.attributes?.name}>
                            <Checkbox checked={selectCategory.indexOf(item?.attributes?.name) > -1} />
                            <ListItemText primary={item?.attributes?.name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: 180 }}>
                <InputLabel id="demo-multiple-checkbox-label">Collection</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectCollection}
                    onChange={handleChangeCollection}
                    input={<OutlinedInput label="Collection" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps1}
                >
                    {isCollection.map((item, index) => (
                        <MenuItem key={index} value={item?.attributes?.name}>
                            <Checkbox checked={selectCollection.indexOf(item?.attributes?.name) > -1} />
                            <ListItemText primary={item?.attributes?.name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: 180 }}>
                <InputLabel id="demo-multiple-checkbox-label">Lumen</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectLumen}
                    onChange={handleChangeLumen}
                    input={<OutlinedInput label="Lumen" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps1}
                >
                    {isLumen.map((item, index) => (
                        <MenuItem key={index} value={item.attributes.Lumen}>
                            <Checkbox checked={selectLumen.indexOf(item?.attributes?.Lumen) > -1} />
                            <ListItemText primary={item?.attributes?.Lumen} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: 180 }}>
                <InputLabel id="demo-multiple-checkbox-label">CCT</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectTemperature}
                    onChange={handleChangeTemperature}
                    input={<OutlinedInput label="CCT" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps1}
                >
                    {isTemperature.map((item, index) => (
                        <MenuItem key={index} value={item?.attributes?.value_temperature}>
                            <Checkbox checked={selectTemperature.indexOf(item?.attributes?.value_temperature) > -1} />
                            <ListItemText primary={item?.attributes?.value_temperature} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: 180 }}>
                <InputLabel id="demo-multiple-checkbox-label">Wattage</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectWattage}
                    onChange={handleChangeWattage}
                    input={<OutlinedInput label="Wattage" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps1}
                >
                    {isWattage.map((item, index) => (
                        <MenuItem key={index} value={item?.attributes?.Watt}>
                            <Checkbox checked={selectWattage.indexOf(item?.attributes?.Watt) > -1} />
                            <ListItemText primary={item?.attributes?.Watt} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: 180 }}>
                <InputLabel id="demo-multiple-checkbox-label">Optics</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectDistribution}
                    onChange={handleChangeDistribution}
                    input={<OutlinedInput label="Optics" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps1}
                >
                    {isDistribution.map((item, index) => (
                        <MenuItem key={index} value={item?.attributes?.Abbreviation}>
                            <Checkbox checked={selectDistribution.indexOf(item?.attributes?.Abbreviation) > -1} />
                            <ListItemText primary={item?.attributes?.Abbreviation} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: 180 }}>
                <InputLabel id="demo-multiple-checkbox-label">Certification</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectCertification}
                    onChange={handleChangeCertification}
                    input={<OutlinedInput label="Certification" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps1}
                >
                    {isCertification.map((item, index) => (
                        <MenuItem key={index} value={item?.attributes?.Name}>
                            <Checkbox checked={selectCertification.indexOf(item?.attributes?.Name) > -1} />
                            <ListItemText primary={item?.attributes?.Name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </React.Fragment>
    );
};

export default SelectFilter;
